export default function Deliverables() {
  const cards = [
    {
      title: '改善レポート（優先順位つき）',
      text: 'どこを、なぜ、どう直すか。すぐ動ける形で整理します。'
    },
    {
      title: '変更後LP構成案（見出し・コピー）',
      text: '"説明"ではなく"自分ごと"に変換した見出しと文章。'
    },
    {
      title: '広告の検証設計（症状KW中心）',
      text: '無駄な配信を避け、最小予算で勝ち筋を見つけます。'
    }
  ];

  return (
    <section id="deliverables" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-[1200px] mx-auto px-6 md:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-gray-900 mb-4">
            提供物（アウトプット）
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {cards.map((card, index) => (
            <div key={index} className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-shadow">
              <div className="w-12 h-12 flex items-center justify-center bg-gray-100 rounded-lg mb-4">
                <i className="ri-file-text-line text-gray-900 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{card.title}</h3>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">{card.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
